import { Loader, LoaderType } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { Book, ClubPastBook } from '@fable/types'
import { getClubBooks } from 'app/clubs/apiHelpers'
import { useClub } from 'app/clubs/hooks'
import { AxiosResponse } from 'axios'
import { Carousel, useCarouselController } from 'components/carousel'
import { useQuery, UseQueryResult } from 'react-query'
import { ClubDetailCarouselControls } from '../../ClubDetailCarouselControls'
import { ClubDetailBook } from './ClubDetailBook'

export const ClubDetailBooks = () => {
  const { mediaQueries } = useTheme()
  const carouselController = useCarouselController()
  const club = useClub()

  const { data, isFetching, error }: UseQueryResult<AxiosResponse> = useQuery(
    ['club-books'],
    () => getClubBooks(club?.id)
  )

  if (isFetching) {
    return (
      <div
        className={css`
          position: relative;
          height: 200px;
        `}
      >
        <Loader type={LoaderType.contained} />
      </div>
    )
  }

  const bookData = data?.data?.results as ClubPastBook[]
  const books = bookData?.filter(
    ({ book }) => book.id !== club?.current_book?.id
  )

  if (error) return null

  return (
    <div
      className={css`
        position: relative;
        ${mediaQueries.tabletL} {
          margin-top: 32px;
        }
      `}
    >
      <ClubDetailCarouselControls controller={carouselController} />
      <Carousel
        controller={carouselController}
        options={{
          slides: { perView: 'auto', spacing: 16, origin: 0 },
        }}
        childWidths={[{ width: '190px', breakpoint: 'base' }]}
        noOverflow
      >
        <ClubDetailBook
          book={club?.current_book as Book}
          hidden={carouselController.currentSlide !== 0}
          currentBook
        />
        {!club?.has_past_books || !books.length
          ? null
          : books.map((pastBook, i) => (
              <ClubDetailBook
                key={i}
                book={pastBook.book}
                hidden={i + 1 < carouselController.currentSlide}
              />
            ))}
      </Carousel>
    </div>
  )
}
